var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"clearable":"","disabled":_vm.tagType === null || _vm.loading,"items":!_vm.isGetID ? _vm.leagues : _vm.leagueList,"loading":_vm.loading}},'v-autocomplete',_vm.attributes,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }